import { VXAPP_BRANDING } from '@/@vxapp/constants'

export type PageTitleValue = string | number | null | undefined

const normalizeTitleValue = (value: PageTitleValue): string => String(value ?? '').trim()

/** Appends the brand once; a blank title shows the brand alone. */
export function formatDocumentTitle(pageTitle: PageTitleValue): string {
  const title = normalizeTitleValue(pageTitle)

  return title ? `${title} | ${VXAPP_BRANDING}` : VXAPP_BRANDING
}

/** `Entity (identifier)`, or `Entity` when the identifier is blank. Never branded. */
export function formatEntityPageTitle(entityName: string, identifier: PageTitleValue): string {
  const name = normalizeTitleValue(entityName)
  const id = normalizeTitleValue(identifier)

  return id ? `${name} (${id})` : name
}

/** The only place the application assigns document.title. */
export function setDocumentTitle(pageTitle: PageTitleValue): void {
  document.title = formatDocumentTitle(pageTitle)
}
